import { useNavigate } from 'react-router-dom'

import BettingServiceSelectionTemplate from '@/components/templates/bettingServiceSelection/bettingServiceSelectionTemplate'

export default function BettingServiceSelectionPage() {
    const navigate = useNavigate()

    return <BettingServiceSelectionTemplate navigate={navigate} />
}
